// Điểm mở rộng của module Quy trình vận hành (FSD.md §2.1, §3.2): không có "Tạo mới", Tìm nhanh hay lớp phủ riêng.
// Số liệu sống của 5 tầng + checklist đến từ module khác ⇒ làm mới GET /process/summary theo chủ đề SSE của chúng
// (gộp tin 3 s; trang không mở ⇒ chỉ đánh dấu cũ, tải lại khi vào trang).
import { qk, type RealtimeBinding } from '@/shared/api';
import type { CreateItem } from '@/widgets/app-shell';

/** Mục "Tạo mới" của module ở thanh trên (lọc theo module bật + quyền). */
export const createItems: CreateItem[] = [];

const summary = () => [qk.process.all];
export const realtime: RealtimeBinding[] = [
  // Tầng 1 (lead 7 ngày, quá SLA) + bước "khách đầu tiên"
  { topic: 'crm.customers', module: 'process', keys: summary, throttleMs: 3000 },
  // Tầng 2 (căn trống / đang giữ)
  { topic: 'booking.units', module: 'process', keys: summary, throttleMs: 3000 },
  // Bước "dự án", "bảng hàng"
  { topic: 'inventory.projects', module: 'process', keys: summary, throttleMs: 3000 },
  // Tầng 3 (phiếu chờ duyệt)
  { topic: 'deals', module: 'process', keys: summary, throttleMs: 3000 },
  // Tầng 4 (người đã vào ca hôm nay)
  { topic: 'attendance', module: 'process', keys: summary, throttleMs: 3000 },
  // Tầng 5 (hoa hồng chờ chi)
  { topic: 'commission.ledger', module: 'process', keys: summary, throttleMs: 3000 },
  { topic: 'commission.payouts', module: 'process', keys: summary, throttleMs: 3000 },
  // Bước "chỉ tiêu tháng"
  { topic: 'sales', module: 'process', keys: summary, throttleMs: 3000 },
];
